import { useState } from 'react';

import {
    Sheet,
    SheetClose,
    SheetCloseButton,
    SheetContent,
    SheetHeader,
    SheetTitle,
} from '@nesso/ui/primitives/sheet';

import type { Service } from '@/entities/service-catalog';

import { SaveServiceSheetForm } from './save-service-sheet/save-service-sheet-form';

type Props = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    service?: Service;
    onSuccess: (code: string) => void;
};

export function SaveServiceSheet({ open, onOpenChange, service, onSuccess }: Props) {
    const [pending, setPending] = useState(false);
    const close = () => onOpenChange(false);

    return (
        <Sheet open={open} onOpenChange={(next) => !pending && onOpenChange(next)}>
            <SheetContent side="right" size="medium" showCloseButton={false}>
                <SheetHeader variant="mini" bordered>
                    <SheetTitle>{service ? 'Edit service' : 'Add service'}</SheetTitle>
                    <SheetClose asChild>
                        <SheetCloseButton />
                    </SheetClose>
                </SheetHeader>
                <SaveServiceSheetForm
                    service={service}
                    onCancel={close}
                    onSaved={(code) => {
                        close();
                        onSuccess(code);
                    }}
                    onPendingChange={setPending}
                />
            </SheetContent>
        </Sheet>
    );
}
